



































































import Vue from 'vue'
import * as R from 'ramda'
import { DataPoint } from '@/jsonapi/CommonTypes'
import { USER_TIME_ZONE } from '@/utils/time'
import { buildCasualNumberOfStepsOptions } from '@/components/patient-stats/graphs/detailed-reports/options/casual-number-of-steps-options'
import { buildWorkDurationOptions } from '@/components/patient-stats/graphs/detailed-reports/options/duration-of-activity-options'
import { buildWalkDistanceOptions } from './options/distance-of-steps-options'
import { buildSedentaryTimeOptions } from './options/sedentary-time-options'

export default Vue.extend({
  props: {
    startTimestamp: {
      type: Number,
      required: true,
    },
    endTimestamp: {
      type: Number,
      required: true,
    },
    patientWithDetailedReports: {
      type: Object,
      default: null,
    },
    patientWithStats: {
      type: Object,
      default: null,
    },
  },
  computed: {
    isNoData(): boolean {
      return !this.casualWalkSteps.length && !this.walkDurations.length
    },
    casualWalkSteps(): DataPoint[] {
      return R.pathOr([], ['activityReport', 'casualWalkSteps'], this.patientWithDetailedReports)
    },
    casualWalkDurations(): DataPoint[] {
      return R.pathOr([], ['casualWalkDurationsPerDay'], this.patientWithStats)
    },
    walkDurations(): DataPoint[] {
      return R.pathOr([], ['activityReport', 'walkDurations'], this.patientWithDetailedReports).filter(
        dp => dp.value !== 0
      )
    },
    sedentaryHours(): DataPoint[] {
      return R.pathOr([], ['activityReport', 'sedentaryDurationInMinutePerDay'], this.patientWithDetailedReports).map(
        dp => ({
          ...dp,
          value: dp.value / 60,
        })
      )
    },
    buildOptions() {
      const { resultStartTimestamp, resultEndTimestamp } = this.patientWithDetailedReports
      const timezone = this.patientWithDetailedReports.timezone || USER_TIME_ZONE
      return {
        resultStartTimestamp,
        resultEndTimestamp,
        timezone,
        colors: this.$vuetify.theme.themes.light,
      }
    },
    casualNumberOfStepsOptions(): echarts.EChartOption<echarts.EChartOption.SeriesBar> {
      let cws = this.casualWalkSteps
      return buildCasualNumberOfStepsOptions({
        ...this.buildOptions,
        casualWalkSteps: this.casualWalkSteps,
        customOptions: {
          grid: [{ x: '5%', y: '5%', width: '90%', height: '80%' } as echarts.EChartOption.Grid],
        },
      })
    },
    durationOfActivityOptions(): echarts.EChartOption<echarts.EChartOption.SeriesLine> {
      return buildWorkDurationOptions({
        ...this.buildOptions,
        walkDurations: this.casualWalkDurations,
      })
    },
    distanceOfActivityOptions(): echarts.EChartOption<echarts.EChartOption.SeriesLine> {
      return buildWalkDistanceOptions({
        ...this.buildOptions,
        casualWalkSteps: this.casualWalkSteps,
      })
    },
    sedentaryTimeOptions(): echarts.EChartOption<echarts.EChartOption.SeriesBar> {
      return buildSedentaryTimeOptions({
        ...this.buildOptions,
        sedentaryHours: this.sedentaryHours,
      })
    },
  },
})
